import { React, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useLogin } from "../../../hooks/useLogin";
import { useTranslation } from "react-i18next";
import "../../../i18n";
function PasswordSettings() {
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordSuggestions, setPasswordSuggestions] = useState([]);
  const [password, setPassword] = useState(""); // use this later to update password
  const [oldPassword, setOldPassword] = useState(""); // use this later to update password
  const [successMessage, setSuccessMessage] = useState("");
  const [unSuccessMessage, setUnSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { updatePassword } = useLogin();
  const { t } = useTranslation();
  const updateHandeler = async (event) => {
    event.preventDefault();
    if (passwordStrength !== "strong") {
      setUnSuccessMessage("Please choose a stronger password.");
      return;
    }

    // Proceed with the API call if the new password is strong
    setIsLoading(true);
    try {
      const response = await updatePassword(oldPassword, password);
      if (response === "Password Updated") {
        setSuccessMessage("Password updated successfully.");
        setOldPassword("");
        setPassword("");
      } else console.log(response);
    } catch (error) {
      console.error("Error during password update:", error);
      setUnSuccessMessage(
        error.response?.data?.message ||
          "An unexpected error occurred. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const checkPasswordStrength = (pwd) => {
    let strength = "strong";
    let suggestions = [];

    if (pwd.length < 8) {
      strength = "weak";
      suggestions.push("Password should be at least 8 characters long.");
    }
    if (!/[A-Z]/.test(pwd)) {
      strength = "weak";
      suggestions.push("Add at least one uppercase letter.");
    }
    if (!/\d/.test(pwd)) {
      strength = "medium";
      suggestions.push("Include at least one number.");
    }
    if (!/[!@#$%^&*]/.test(pwd)) {
      strength = "weak";
      suggestions.push("Use at least one special character (@, #, $,!,...).");
    }

    setPasswordStrength(strength);
    setPasswordSuggestions(suggestions);
  };

  const handlePasswordChange = (e) => {
    const pwd = e.target.value;
    setPassword(pwd);
    checkPasswordStrength(pwd);
  };

  const handleOldPasswordChange = (e) => {
    const opwd = e.target.value;
    setOldPassword(opwd);
  };
  return (
    <>
      {successMessage && (
        <div className="message-box" aria-live="polite">
          {successMessage}
        </div>
      )}
      {unSuccessMessage && (
        <div className="error-message-box" aria-live="polite">
          {unSuccessMessage}
        </div>
      )}
      <div className="settingsDecription">
        <p> {t("updateYourPasswordHere")} </p>
        <Form>
          <div className="mb-3 col-4">
            <label htmlFor="oldPassword" className="form-label">
              {t("oldPassword")}
            </label>
            <input
              id="oldPassword"
              type="password"
              name="oldPassword"
              className="form-control"
              autoComplete="current-password"
              onChange={handleOldPasswordChange}
              required
            />
          </div>
          <div className="mb-3 col-4">
            <label htmlFor="newPassword" className="form-label"></label>
            {t("newPassword")}
            <input
              id="password"
              type="password"
              name="password"
              className="form-control"
              autoComplete="new-password"
              onChange={handlePasswordChange}
              required
            />
          </div>
          <p className={`password-strength ${passwordStrength}`}>
            {t("passwordStrength")} {passwordStrength}
          </p>
          {passwordSuggestions.length > 0 && (
            <ul className="password-suggestions">
              {passwordSuggestions.map((suggestion, index) => (
                <li key={index}>{suggestion}</li>
              ))}
            </ul>
          )}
          <Button
            className="reset-consent-button btn btn-success  px-3 py-1 fw-bold"
            type="submit"
            onClick={updateHandeler}
          >
            {t("updateYourPassword")}{" "}
          </Button>
        </Form>
      </div>
    </>
  );
}

export default PasswordSettings;
